<template>
     <el-row span="24">
        <el-col :span="24">
            <el-form ref="form" label-position="top" v-if="getSettingsAddons.norcloud > 0">
                <el-row :gutter="25">
                    <el-col :lg="12">
                        <el-form-item class="el-form-item-full" :label="$l('settings/norcloud/IdNor')">
                            <el-input disabled v-model="getSettingsDevice.devid"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="12">
                        <el-form-item class="el-form-item-full" :label="$l('settings/norcloud/syncTime')">
                            <el-select :disabled="getSettingsAddons.norcloud == '0'" v-model="getSettingsNorCloud.sendTime" :placeholder="$l('common/select')">
                                <el-option :label="$l('settings/norcloud/disable')" value="0"></el-option>
                                <el-option :label="'1 '+ $l('settings/norcloud/hour')" value="60"></el-option>
                                <el-option :label="'12 '+ $l('settings/norcloud/hour')" value="720"></el-option>
                                <el-option :label="'24 '+ $l('settings/norcloud/hour')" value="1440"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :sm="12" :md="12" :lg="12">
                        <el-form-item class="el-form-item-full" :label="$l('settings/norcloud/syncData')">
                            <el-switch on-text="" off-text="" v-model="getSettingsNorCloud.sendData" on-value="1" off-value="0"></el-switch>
                        </el-form-item>
                    </el-col>   
                    <el-col :sm="12" :md="12" :lg="12">
                        <el-form-item class="el-form-item-full" :label="$l('settings/norcloud/syncRec')">
                            <el-switch on-text="" off-text="" v-model="getSettingsNorCloud.sendRec" on-value="1" off-value="0"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :sm="12" :md="12" :lg="24">
                         <el-form-item class="el-form-item-full" :label="$l('settings/norcloud/sendAlerts')">
                            <el-switch on-text="" off-text="" v-model="getSettingsNorCloud.sendAlerts" on-value="1" off-value="0"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="12">
                        <el-form-item class="el-form-item-full" :label="$l('settings/norcloud/recSett')">
                            <el-switch on-text="" off-text="" v-model="getSettingsNorCloud.receiveSett" on-value="1" off-value="0"></el-switch>
                        </el-form-item>
                    </el-col>
 
                    <el-col :md="12" :lg="12">
                        <el-form-item class="el-form-item-full" v-if="getSettingsNorCloud.receiveSett == '1'">
                            <!--div class="recSettContainer">
                                <el-row :gutter="25">
                                    <el-col :sm="24" :md="24" :lg="24"-->
                                        <el-form-item class="el-form-item-full" :label="$l('settings/norcloud/applySett')">
                                            <el-select v-model="getSettingsNorCloud.updSett" :placeholder="$l('common/select')">
                                                <el-option :label="$l('settings/norcloud/now')" value="now"></el-option>
                                                <el-option :label="$l('settings/norcloud/fhour')" value="fhour"></el-option>
                                                <el-option :label="$l('settings/norcloud/break')" value="break"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    <!--/el-col>
                                </el-row>
                            </div-->
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-col>
    </el-row>
</template>

<style scoped>
    .recSettContainer{
        padding:10px;
        border: 1px solid #e1e5ec;
        margin-top:3px;
    }
</style>

<script>
import { mapGetters } from 'vuex'
export default {
    computed:{
         ...mapGetters([
            'getSettingsAdio',
            'getSettingsVideo',
            'getSettingsNorCloud',
            'getSettingsDevice',
            'getSettingsAddons'
        ]),
    },
    methods: {
        onSubmit() {
            var item
            console.log('submit!');
        },
    }
}
</script>





// WEBPACK FOOTER //
// NorCloud.vue?7d93fd7c